import { render, staticRenderFns } from "./StayingBillModal.vue?vue&type=template&id=87ad06d4&"
import script from "./StayingBillModal.vue?vue&type=script&lang=js&"
export * from "./StayingBillModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports